

import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { IoArrowUndoSharp } from "react-icons/io5";
import { CommonContext } from "../../../App";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../../../Components/CommonComponent/loadingSpiner/LoadingSpinner";
import ContactMarquee from "../../../Components/CommonComponent/Table/ContactMarquee";
import api from "../../../services/api";

export default function LedgerTables() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { ledger, againAddbtn, btnHeading, btnlink, entry } = location.state || {};
  // console.log(location.state )

  const [addbtn, setAddbtn] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [totalOpening, setTotalOpening] = useState(0);
  const [openingType, setOpeningType] = useState("Dr");

  const [totalDebitAmount, setTotalDebitAmount] = useState(0);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalOpeningQuantity, setTotalOpeningQuantity] = useState(0);

  const [closingBalance, setClosingBalance] = useState(0);
  const [closingType, setClosingType] = useState("Dr");


  const { branchId, dateRange, setDateRange } = useContext(CommonContext);
  const [startDate, setStartDate] = useState(dateRange.startDate);
  const [endDate, setEndDate] = useState(dateRange.endDate);
  const primeLanguage = localStorage.getItem("selectedLanguage");
  useEffect(() => {
    setStartDate(dateRange.startDate);
    setEndDate(dateRange.endDate);
  }, [dateRange]);


  const [focusedRowIndex, setFocusedRowIndex] = useState(null);
  const [selectedRows, setSelectedRows] = useState(new Set());

  const containerRef = useRef(null);
  useEffect(() => {
    const el = containerRef.current;

    const handleClick = () => el?.focus();

    el?.addEventListener("click", handleClick);

    return () => el?.removeEventListener("click", handleClick);
  }, []);
  useEffect(() => {
    containerRef.current?.focus();
  }, []);
  useEffect(() => {
    setFocusedRowIndex(null);
    setSelectedRows(new Set());
  }, [tableData]);
  const handleTableKeyDown = (e) => {
    if (!tableData.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setFocusedRowIndex((prev) =>
        prev === null ? 0 : Math.min(prev + 1, tableData.length - 1)
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setFocusedRowIndex((prev) =>
        prev === null ? null : Math.max(prev - 1, 0)
      );
    }

    // SPACE → select
    if (e.key === " ") {
      e.preventDefault();

      if (focusedRowIndex === null) return;

      setSelectedRows((prev) => {
        const newSet = new Set(prev);

        if (newSet.has(focusedRowIndex)) {
          newSet.delete(focusedRowIndex);
        } else {
          newSet.add(focusedRowIndex);
        }

        return newSet;
      });
    }

    // ENTER → navigate
    if (e.key === "Enter") {
      e.preventDefault();

      if (focusedRowIndex !== null) {
        handleRowClick(tableData[focusedRowIndex]);
      }
    }

    // ESC → back
    if (e.key === "Escape") {
      e.preventDefault();
    navigate("/account-books/sub-group-table", { state: { ledger, addbtn, entry  } });
    }
  };
  useLayoutEffect(() => {
    if (focusedRowIndex === null) return;

    const container = containerRef.current;
    const row = document.getElementById(`row-${focusedRowIndex}`);

    if (!container || !row) return;

    const containerHeight = container.clientHeight;
    const scrollTop = container.scrollTop;

    const rowTop = row.offsetTop;
    const rowHeight = row.offsetHeight;

    const rowCenter = rowTop + rowHeight / 2;
    const containerCenter = scrollTop + containerHeight / 2;

    const OFFSET = 60;

    if (rowCenter > containerCenter + OFFSET) {
      container.scrollTo({
        top: rowTop - containerHeight / 2 + rowHeight,
        behavior: "smooth",
      });
    } else if (rowCenter < containerCenter - OFFSET) {
      container.scrollTo({
        top: rowTop - containerHeight / 2,
        behavior: "smooth",
      });
    }
  }, [focusedRowIndex]);
  // Determine Add Button
  useEffect(() => {
    if (!ledger) return;

    if (ledger.id === undefined || ledger.id === null || againAddbtn) {
      setAddbtn(true);
    } else {
      setAddbtn(false);
    }
  }, [ledger]);

  // MAIN FETCH USEEFFECT
  useEffect(() => {
    if (!ledger && !entry) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const [allLedgersRes, summaryRes] = await Promise.all([
          api.get(`ledgers/get-all-ledger?branchId=${branchId}`),
          api.get(`ledgers/get-balance-sheet`, {
            params: { startDate, endDate, branchId },

          }),
        ]);

        if (allLedgersRes.data.success && summaryRes.data.success) {
          const allLedgers = allLedgersRes.data.allData;
          const allSummary =
            summaryRes.data.data.flatMap((b) => b.branchData || []) || [];

          // Extract rules for filtering (Ledger or Entry)
          const filterGroupType = ledger?.groupType || entry?.type;
          const filterGroupName = ledger?.groupName || entry?.group_name;
          const filterSubGroupName =
            ledger?.subGroupName || entry?.sub_group_name;

          //  Corrected Filtering
          const filteredLedgers = allLedgers.filter((item) => {
            const matchGroup = item.groupType === filterGroupType;
            const matchGroupName = item.groupName === filterGroupName;
            const matchSubGroup = filterSubGroupName
              ? item.subGroupName === filterSubGroupName
              : true;

            return matchGroup && matchGroupName && matchSubGroup;
          });

          // Map rows with calculations
          const mapped = filteredLedgers.map((item) => {
            const summaries = allSummary.filter(
              (s) =>
                s.groupType === item.groupType &&
                s.groupName === item.groupName &&
                (s.ledgerName === item.name || s.ledgerId === item.id)
            );

            const openingReceived = summaries.reduce(
              (sum, s) => sum + Math.abs(s.openingReceived || 0),
              0
            );

            const openingPaid = summaries.reduce(
              (sum, s) => sum + Math.abs(s.openingPaid || 0),
              0
            );

            const openingValue = Math.abs(openingReceived - openingPaid);

            const openingType =
              openingValue > 0
                ? openingReceived >= openingPaid
                  ? "Dr"
                  : "Cr"
                : "";

            // ✅ Current Period
            const debit = summaries.reduce(
              (sum, s) => sum + Math.abs(s.currentReceived || 0),
              0
            );

            const credit = summaries.reduce(
              (sum, s) => sum + Math.abs(s.currentPaid || 0),
              0
            );

            const openingQuantity = summaries.reduce(
              (sum, s) => sum + Math.abs(s.prevQuantity || 0),
              0
            );

            const quantity = summaries.reduce(
              (sum, s) => sum + Math.abs(s.totalQuantity || 0),
              0
            );

            let closing;
            let closingType;

            if (
              item.groupType === "Assets" ||
              item.groupType === "Liability"
            ) {
              // const netChange = openingType === "Dr" && openingValue > 0
              //  ? openingValue + debit - credit: -openingValue - debit + credit
              // closing = Math.abs(netChange);
              // closingType = openingValue > 0 ? netChange >= 0 ? "Dr" : "Cr":debit > credit ? "Dr" : "Cr"
              // Step 1: Opening ko signed me convert karo
              const openingSigned =
                openingType === "Dr"
                  ? openingValue
                  : openingType === "Cr"
                    ? -openingValue
                    : 0;

              // Step 2: Closing calculate karo
              const closingSigned =
                openingSigned + debit - credit;

              // Step 3: Final values set karo
              closing = Math.abs(closingSigned);

              closingType =
                closingSigned > 0
                  ? "Dr"
                  : closingSigned < 0
                    ? "Cr"
                    : "";

            } else {
              closing = Math.abs(debit - credit);
              closingType = debit > credit ? "Dr" : "Cr";
            }

            return {
              ...item,
              openingValue,
              openingType,
              debit,
              credit,
              closing,
              closingType,
              openingQuantity,
              quantity,
            };
          });

          const nonZeroRows = mapped.filter((r) => {

            // 🔹 Income / Expense → only current period transaction matter
            if (filterGroupType === "Income" || filterGroupType === "Expense") {
              return r.debit !== 0 || r.credit !== 0;
            }

            // 🔹 Assets / Liability → opening bhi valid hai
            return (
              r.openingValue !== 0 ||
              r.debit !== 0 ||
              r.credit !== 0 ||
              r.closing !== 0
            );
          });
          setTableData(nonZeroRows);

          const totalOpeningSigned = nonZeroRows.reduce(
            (sum, r) =>
              sum +
              r.openingValue *
              (r.openingType === "Dr" ? 1 : r.openingType === "Cr" ? -1 : 0),
            0
          );

          setTotalOpeningQuantity(
            nonZeroRows.reduce((sum, r) => sum + (r.openingQuantity || 0), 0)
          );

          setTotalQuantity(
            nonZeroRows.reduce((sum, r) => sum + (r.quantity || 0), 0)
          );

          // Opening Set
          setTotalOpening(Math.abs(totalOpeningSigned));
          setOpeningType(
            totalOpeningSigned > 0
              ? "Dr"
              : totalOpeningSigned < 0
                ? "Cr"
                : ""
          );

          const totalDebit = nonZeroRows.reduce(
            (sum, r) => sum + r.debit,
            0
          );

          const totalCredit = nonZeroRows.reduce(
            (sum, r) => sum + r.credit,
            0
          );

          setTotalDebitAmount(totalDebit);
          setTotalCreditAmount(totalCredit);

          // ✅ ===== FIXED CLOSING CALCULATION =====

          // Correct Accounting Formula:
          // Closing = Opening + Debit - Credit

          let finalClosingSigned = 0;

          if (groupType === "Income" || groupType === "Expense") {

            finalClosingSigned = totalDebit - totalCredit;

          } else {

            finalClosingSigned =
              totalOpeningSigned + totalDebit - totalCredit;

          }

          setClosingBalance(Math.abs(finalClosingSigned));

          setClosingType(
            finalClosingSigned > 0
              ? "Dr"
              : finalClosingSigned < 0
                ? "Cr"
                : ""
          );
        }
      } catch (err) {
        console.error("Error:", err);
      } finally {
        setLoading(false);
      }
    };
    if (startDate && endDate && branchId) {
      fetchData();

    }
  }, [ledger, entry, startDate, endDate, branchId]);

  // NEW FIXED CONDITION
  const groupType = ledger?.groupType || entry?.type;
  const showOpening = groupType !== "Expense" && groupType !== "Income";
  const showQuantity = groupType !== "Assets" && groupType !== "Liability";
  const subGroupNameHi =
    ledger?.subGroupNameInHindi ||
    entry?.subGroupNameInHindi ||
    ledger?.subGroups?.accounts?.subGroupNameInHindi ||
    "";

  const subGroupNameEn =
    ledger?.subGroupName ||
    entry?.subGroupName ||
    entry?.sub_group_name ||
    ledger?.subGroups?.accounts?.subGroupName ||
    "";


  // Navigate to ledger details
  const handleRowClick = (row) => {
    navigate("/account-books/ledger-details", {
      state: { ledger: row, addbtn, btnHeading, btnlink },
    });
  };

  return (
    <div className="container_fluid">
      <div className="py-1">
        <div className="px-0 p-1 sticky top-0">
          <div className="flex gap-3">
            <div className="mt-[2px]">
              <NavLink
                to="/account-books/sub-group-table"
                state={{ ledger, addbtn, entry }}
                className="inline-block p-1 px-2 text-theme-backBtn border-1 border-theme-backBtn rounded cursor-pointer hover:bg-theme-backBtn hover:text-theme-color"
              >
                <IoArrowUndoSharp />
              </NavLink>
            </div>

            <div>
              {(addbtn || againAddbtn) && (
                <NavLink
                  to={btnlink}
                  className=" inline-block py-[2px] px-2  no-underline text-theme-backBtn border-1 border-theme-backBtn rounded cursor-pointer hover:bg-theme-backBtn hover:text-theme-color  font-medium "
                >
                  {btnHeading}
                </NavLink>
              )}
            </div>
          </div>
        </div>

        <div className="flex justify-between border-b py-[2px]  bg-theme-headerBg text-theme-color  px-2 ">
          <div className="text font-medium py-[2px] text-sm">
            {/* {t("ledgers")} */}
            {/* {primeLanguage === "hi"
                      ? `${(ledger.subGroupNameInHindi && ledger.subGroupNameInHindi) || (entry.subGroupNameInHindi && entry.subGroupNameInHindi) || (ledger.subGroups.Customers.subGroupNameInHindi  && ledger.subGroups.Customers.subGroupNameInHindi) } ${t("ledgerOf")}`
                      : `${t("ledgerOf")} ${ledger?.subGroupName || entry?.subGroupName || ledger?.subGroups?.Customers?.subGroupName} (${ledger.subGroupNameInHindi || entry?.subGroupNameInHindi || ledger?.subGroups?.Customers?.subGroupNameInHindi})`
                    } */}

            {/* {primeLanguage === "pn" || primeLanguage === "en"
              ? `${t("ledgerOf")} ${ledger?.subGroupName || entry?.subGroupName || ledger?.subGroups?.Customers?.subGroupName} (${ledger.subGroupNameInHindi || entry?.subGroupNameInHindi || ledger?.subGroups?.Customers?.subGroupNameInHindi})`
              : `${(ledger.subGroupNameInHindi && ledger.subGroupNameInHindi) || (entry.subGroupNameInHindi && entry.subGroupNameInHindi) || (ledger.subGroups.Customers.subGroupNameInHindi  && ledger.subGroups.Customers.subGroupNameInHindi) } ${t("ledgerOf")}`
              } */}

            {
              primeLanguage === "hi"
                ? `${ledger?.subGroupNameInHindi ||
                entry?.subGroupNameInHindi ||
                ledger?.subGroups?.Customers?.subGroupNameInHindi ||
                ""
                } ${t("ledgerOf")}`
                : `${t("ledgerOf")} ${ledger?.subGroupName ||
                entry?.subGroupName ||
                ledger?.subGroups?.Customers?.subGroupName ||
                ""
                }${primeLanguage === "en"
                  ? ` (${ledger?.subGroupNameInHindi ||
                  entry?.subGroupNameInHindi ||
                  ledger?.subGroups?.Customers?.subGroupNameInHindi ||
                  ""
                  })`
                  : ""
                }`
            }
          </div>
        </div>

        <div
          ref={containerRef}
          tabIndex={0}
          onKeyDown={handleTableKeyDown}
          className=" overflow-auto outline-none"
        >
          <table className="min-w-full bg-theme-tableBg  text-sm  border-separate border-spacing-0 capitalize">
            <thead>
              <tr className="bg-white text-theme-headerBg border-b border-theme-headerBg">
                <th className=" px-1 py-[2px] text-center border-b font-medium">{t("srNumber")}</th>
                <th className=" px-1 w-40 font-medium border-b  ">{t("ledgerName")}</th>

                {showOpening && (
                  <th className=" px-1 text-end font-medium border-b">
                    {t("openingBalance")}
                  </th>
                )}
                {/* {showQuantity && (
                  <>
                    <th className="border px-1 text-center font-medium">Opening Qty</th>
                    <th className="border px-1 text-center font-medium" >Current Qty</th>
                  
                  </>
                )} */}

                <th className=" px-1 text-end font-medium border-b">{t("receivedDr")}</th>
                <th className=" px-1 text-end font-medium border-b">{t("paidCr")}</th>
                <th className=" px-1 text-end font-medium border-b">{t("closingBalance")}</th>
              </tr>
            </thead>

            {!loading && (
              <>
                <tbody>
                  {tableData.length > 0 ? (
                    tableData.map((row, i) => (
                      <tr
                        id={`row-${i}`}
                        key={i}
                        onClick={() => {
                          setFocusedRowIndex(i); //  click se focus sync
                          handleRowClick(row);
                        }}
                        className={`
    cursor-pointer transition-colors duration-150
    ${focusedRowIndex === i
                            ? "bg-[#5c5b5b] text-white "       //  FOCUS (priority high)
                            : selectedRows.has(i)
                              ? "bg-[#f4c48a]"     //  SELECTED (fallback)
                              : ""
                          }
  `}
                      >
                        <td className="border-b px-1 text-center">{i + 1}</td>

                        <td className="border-b  w-96">
                          <div className="w-96 px-1">
                            <div className="flex gap-2 justify-center">
                              {/* <strong className="font-medium  text-[14px]">
                            {row.name || row.customerName || row.accountName}
                          </strong>
                          <div>
                             {row.cousinName && row.cousinName}
                          </div> */}
                              <ContactMarquee firstName={row.name || row.customerName || row.accountName} secondName={row.cousinName} />

                            </div>
                            <ContactMarquee
                              phoneVal={row.phone}
                              addressVal={row.address}
                            // cousinName={row.cousinName}
                            />
                          </div>
                        </td>

                        {showOpening && (
                          <td className="border-b px-1 text-end">
                            {row.openingValue.toLocaleString()} {row.openingType}
                          </td>
                        )}
                        {/* {showQuantity && (
                          <>
                            <td className="border px-1 text-end">
                              {row.openingQuantity.toLocaleString()}
                            </td>

                            <td className="border px-1 text-end">
                              {row.quantity.toLocaleString()}
                            </td>

                          </>
                        )} */}

                        <td className="border-b px-1 text-end">
                          {row.debit.toLocaleString()}
                        </td>
                        <td className="border-b px-1 text-end">
                          {row.credit.toLocaleString()}
                        </td>
                        <td className="border-b px-1 text-end">
                          {row.closing.toLocaleString()} {row.closingType}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="6"
                        className="border-b px-4 py-4 text-center text-gray-500 text-sm"
                      >
                        {t("noDataAvailable")}
                      </td>
                    </tr>
                  )}
                </tbody>

                {tableData.length > 0 && (
                  <tfoot>
                    <tr className="bg-white border-b border-theme-headerBg">
                      <td colSpan="2" className="border-b py-[2px] text-start ps-3 font-semibold">
                        {t("total")}:
                      </td>

                      {showOpening && (
                        <td className="border-b px-1 text-end font-semibold">
                          {totalOpening.toLocaleString()} {openingType}
                        </td>
                      )}

                      <td className="border-b px-1 text-end font-semibold">
                        {totalDebitAmount.toLocaleString()}
                      </td>
                      <td className="border-b px-1 text-end font-semibold">
                        {totalCreditAmount.toLocaleString()}
                      </td>
                      <td className="border-b px-1 font-semibold text-end">
                        {closingBalance.toLocaleString()} {closingType}
                      </td>
                    </tr>
                  </tfoot>
                )}
              </>
            )}
          </table>
        </div>

        {loading && (
          <div className="flex justify-center my-4">
            <LoadingSpinner size={70} color="#000000" />
          </div>
        )}
      </div>
    </div>
  );
}